// Módulos nativos (AstraChat) liberados por empresa no Super Admin.
// Só o booleano true libera; ausência de dado é tratada como desligado.
export const isModuleEnabledForAccount = (account, moduleKey) =>
  account?.feature_modules?.[moduleKey] === true;
